export class InvalidHashkeyRequested extends Error {
  constructor(message) {
    super(message);
  }
}

